import { useParams } from 'react-router-dom'

import { AsyncBlock } from '../components/AsyncBlock'
import { ProjectHeading } from '../components/ProjectHeading'
import { api, type Photo } from '../lib/api'
import { fmtDate, humanize } from '../lib/format'
import { useAsync } from '../lib/useAsync'

function PhotoTile({ photo }: { photo: Photo }): JSX.Element {
  return (
    <figure className="photo-tile">
      <img
        src={photo.file_url}
        alt={photo.caption ?? 'Project photo'}
        loading="lazy"
      />
      <figcaption>
        <span className="photo-caption">{photo.caption ?? 'Project photo'}</span>
        <span className="photo-meta">
          {photo.phase ? `${humanize(photo.phase)} · ` : ''}
          {fmtDate(photo.taken_at ?? photo.uploaded_at)}
        </span>
      </figcaption>
    </figure>
  )
}

export function PhotosPage(): JSX.Element {
  const { projectId = '' } = useParams()
  const state = useAsync(() => api.photos(projectId), `photos-${projectId}`)
  return (
    <div className="page">
      <ProjectHeading projectId={projectId} title="Photos" />
      <AsyncBlock
        state={state}
        isEmpty={(d) => d.photos.length === 0}
        emptyText="No photos have been shared yet."
      >
        {(d) => (
          <div className="photo-grid">
            {d.photos.map((p) => (
              <PhotoTile key={p.id} photo={p} />
            ))}
          </div>
        )}
      </AsyncBlock>
    </div>
  )
}
